import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyAddressSearchLoupe } from '@root/entities/currency/ui/currency-address-search-loupe'
import { CurrencyInformationClipboard } from '@root/entities/currency/ui/currency-information'

import type { CurrencyModel } from '@root/entities/currency/model'
import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type PairOrCurrency =
  | {
      pair: PairModel
      currency?: undefined
    }
  | {
      pair?: undefined
      currency: CurrencyModel
    }

type PairSublineProps = {
  withAge?: boolean
  iconSize?: number
} & PairOrCurrency &
  ClassNameProps

export const PairSubline: React.FC<PairSublineProps> = ({
  pair,
  currency,
  iconSize = 12,
  className,
}) => {
  const currency_ = pair ? pair.quote : currency

  return (
    <Root className={className}>
      <Title variant="body5-regular" ellipsis>
        {currency_.title}
      </Title>
      <CurrencyInformationClipboard currency={currency_} size={iconSize} />
      <CurrencyAddressSearchLoupe
        currencyAddress={currency_.address}
        symbol={currency_.ticker}
        size={iconSize}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;

  gap: 4px;
  color: var(--text-7);
`

const Title = styled(Typography)``
